"use client";

import { IFilters } from "@/types/spots/filters";
import { ISpot } from "@/types/spots/spot";

export async function fetchSpots(filters: IFilters): Promise<ISpot[]> {
  const params = new URLSearchParams(
    Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && value !== "") acc[key] = value.toString();
      return acc;
    }, {} as Record<string, string>)
  );

  const response = await fetch(`/api/garage-items?${params.toString()}`, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Erreur lors de la récupération des spots: ${response.statusText}`);
  }

  const data: ISpot[] = await response.json();
  return data;
}
